import _ from 'lodash';
import React from 'react';
import {Field} from 'redux-form';

import {required as requiredValidator} from 'utils/validators';
import {SearchField} from 'components/Fields';

const DEFAULT_PLACEHOLDER = 'Select country';
const DEFAULT_FIELD_NAME = 'country';

import './styles.css';

export const buildCountrySelectizeOption = country => ({
  value: country.code,
  label: country.name
});

const SearchCountryField = ({
  onChange,
  countries,
  disabled,
  required,
  name = DEFAULT_FIELD_NAME,
  placeholder
}: any) => {
  const validators = required ? [requiredValidator] : [];
  placeholder = _.isNil(placeholder) ? DEFAULT_PLACEHOLDER : placeholder;

  return (
    <div className="SearchCountryField">
      <Field
        name={name}
        validate={validators}
        component={SearchField}
        onChange={onChange}
        options={countries.map(buildCountrySelectizeOption)}
        disabled={disabled || countries.length < 2}
        placeholder={placeholder}
      />
    </div>
  );
};

export default SearchCountryField;
